import { createSlice } from '@reduxjs/toolkit'
import { RootState, AppThunk } from './store'
import { Activity } from 'types/types'

export interface PreviewActivityState {
  activity: Activity | null
}

const emptyState = {
  activity: null,
}

const createInitialState = (): PreviewActivityState => {
  if (localStorage.getItem('activity') == null) {
    return emptyState
  } else {
    return JSON.parse(localStorage.getItem('activity') as string) as PreviewActivityState
  }
}

const writeState = (state: PreviewActivityState) => {
  localStorage.setItem('activity', JSON.stringify(state))
}

const clearState = () => {
  localStorage.removeItem('activity')
}

export const previewActivitySlice = createSlice({
  name: 'previewActivity',
  initialState: createInitialState(),
  reducers: {
    fetchActivitySuccess: (state, action) => {
      state.activity = action.payload
      writeState(state)
    },
    removeActivitySuccess: (state) => {
      state.activity = null
      clearState()
    },
  },
})

export const { fetchActivitySuccess, removeActivitySuccess } = previewActivitySlice.actions

export const savePreviewActivity =
  (activity: Activity): AppThunk =>
  async (dispatch) => {
    dispatch(fetchActivitySuccess(activity))
  }

//
export const removePreviewActivity = (): AppThunk => async (dispatch) => {
  dispatch(removeActivitySuccess())
}

export const selectPreviewActivity = (state: RootState): Activity | null => state.previewActivity.activity
export default previewActivitySlice.reducer
